import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { isPosHost } from './App';
import { registerSW, activateUpdate } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Le splash HTML est retiré par App.jsx (useEffect) une fois que React a vraiment monté.
// On ne le retire pas avec requestAnimationFrame ici, sinon sur connexion lente
// l'utilisateur voit un écran noir pendant que les chunks JS se téléchargent.

// PWA : enregistrement du service worker.
// Quand une nouvelle version est déployée sur Railway, on propose à l'utilisateur
// de recharger pour la prendre.
registerSW({
  onUpdate: (reg) => {
    // Caisse : pas de boite de dialogue. Elle prend le clavier, et l'Entree
    // finale d'un scan (badge, article) valide « OK » sans que personne l'ait
    // lue : la page se recharge et le panier en cours est perdu. La mise a
    // jour attend la fin de la vente (PosSale, bouton « Terminer »).
    if (isPosHost()) { window.__majCaisseEnAttente = reg; return; }
    if (window.confirm('Une nouvelle version de Datashipset est disponible. Recharger maintenant ?')) {
      activateUpdate(reg);
    }
  },
});
